import { DataColumn, GroupColumn } from "./types"

export const getColumnId = <T>(column: DataColumn<T>, group?: GroupColumn<T>) =>
  [group?.title, column.title].filter(Boolean).join("-")
